import { FieldGroup } from "./columnGroups";

// Same localStorage key the old, now-removed CourseStudentsSaveColumns.tsx used, so
// previously saved views keep working.
const SAVED_SETS_KEY = "student_fields_sets";

export type FieldSet = {
  name: string;
  fields?: string[];
  // Legacy shape (pre-ordering) — read for backward compatibility, never written.
  baseUserProps?: string[];
  paymentProps?: string[];
  registrationProps?: string[];
  notesProps?: string[];
};

export const loadSavedSets = (): FieldSet[] => {
  const raw = localStorage.getItem(SAVED_SETS_KEY);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const saveFieldSet = (set: FieldSet): void => {
  const current = loadSavedSets();
  const updated = [...current.filter((s) => s.name !== set.name), set];
  localStorage.setItem(SAVED_SETS_KEY, JSON.stringify(updated));
};

export const deleteFieldSet = (name: string): void => {
  const current = loadSavedSets();
  const updated = current.filter((s) => s.name !== name);
  localStorage.setItem(SAVED_SETS_KEY, JSON.stringify(updated));
};

export const buildFieldSetFromSelection = (name: string, selectedFields: string[]): FieldSet => ({
  name,
  fields: selectedFields,
});

// Falls back to the pre-ordering 4-group shape for sets saved before this change, then drops
// any key that no longer exists in the current groups (deleted tranche/custom form field).
export const getOrderedFields = (set: FieldSet, groups: FieldGroup[]): string[] => {
  const order =
    set.fields ??
    [
      ...(set.baseUserProps ?? []),
      ...(set.paymentProps ?? []),
      ...(set.registrationProps ?? []),
      ...(set.notesProps ?? []),
    ];
  const validKeys = new Set(groups.flatMap((g) => g.fields).map((f) => f.key));
  return order.filter((key) => validKeys.has(key));
};
